module.exports = __webpack_public_path__ + "img/missing_paper_towel.1478b4d0.svg";